import { CURRENCY } from "@/data/numbers";
import { routes } from "@/data/routes";
import { formatPrice } from "@/lib/numbers";
import { type Product } from "@repo/schemas";
import Image from "next/image";
import Link from "next/link";

export function ProductCard({ product }: { product: Product }) {
  const productImages = product.images.filter((pimg) => pimg.type === "small");
  return (
    <article>
      <Link
        href={`${routes.productDetails.path.replace(":id", product.id)}`}
        className="flex flex-col gap-1 hover:opacity-80"
      >
        <div className="group relative aspect-square w-full">
          {productImages.length > 0 && (
            <>
              {productImages.length >= 2 && (
                <Image
                  src={productImages[1].src ?? productImages[0].src}
                  alt={product.title}
                  fill
                  sizes="(max-width: 768px) 900vw, 300px"
                  className="transition-opacity duration-300 group-hover:opacity-0"
                />
              )}
              <Image
                src={productImages[0].src}
                alt={product.title}
                fill
                sizes="(max-width: 768px) 900vw, 300px"
                className="opacity-0 transition-opacity duration-500 group-hover:opacity-100"
              />
            </>
          )}
        </div>
        <h3 className="font-didone font-bold">{product.brand}</h3>
        <p className="font-inter overflow-hidden text-xs text-ellipsis whitespace-nowrap">
          {product.title}
        </p>
        <p className="text-lg font-bold">{formatPrice(product.price, CURRENCY)}</p>
      </Link>
    </article>
  );
}
